export default {
    notifications: {
        upload_success: 'Files uploaded successfully',
    },
}
